'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hubs;

var _immutable = require('immutable');

var _HubsDataActionTypes = require('../actionTypes/HubsDataActionTypes');

var _utmHelpers = require('../utils/utmHelpers.js');

var DEFAULT = (0, _immutable.Map)({
  hubsToUtm: new _immutable.Map(),
  hubs: new _immutable.Map()
});

function hubs() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case _HubsDataActionTypes.HUBS_DATA_FETCHED:
      {
        return state.merge((0, _immutable.fromJS)({
          hubsToUtm: (0, _utmHelpers.hubsToUtmData)(payload),
          hubs: (0, _utmHelpers.additionalHubsData)(payload)
        }));
      }
    default:
      {
        return state;
      }
  }
}
module.exports = exports['default'];